import axios from 'axios'
import {
  timeoutRetryRejectionInterceptor,
  betterErrorsRejectionInterceptor
} from './interceptors'

const axiosVerbose = axios.create({
  timeout: 10000
})

axiosVerbose.interceptors.response.use(
  undefined,
  timeoutRetryRejectionInterceptor
)
axiosVerbose.interceptors.response.use(
  undefined,
  betterErrorsRejectionInterceptor
)

export default axiosVerbose



// WEBPACK FOOTER //
// ./common/utils/axios/axiosVerbose.js